export default class Logger {
  private static console: Console = window.console;
  private static LOG_LEVEL: number = parseInt(process.env.VUE_APP_LOG_LEVEL || '3');
  /*
  LOG_LEVEL
  1: error
  2: warn
  3: info
  4: LOG
  5: debug
   */
  private static getLogLevel(): number {
    let logLevel: any = (<any>window)['LOG_LEVEL'];
    return logLevel? parseInt(logLevel) : Logger.LOG_LEVEL ;
  }

  public static error(message: any) {
    if (Logger.getLogLevel() >= 1) {
      console.error(message || 'null');
    }
  }
  public static warn(message: any) {
    if (Logger.getLogLevel() >= 2) {
      console.warn(message || 'null');
    }
  }
  public static info(message: any) {
    if (Logger.getLogLevel() >= 3) {
      console.info(message || 'null');
    }
  }

  public static log(message: any) {
    if (Logger.getLogLevel() >= 4) {
      console.info(message || 'null');
    }
  }
  public static debug(message: any) {
    if (Logger.getLogLevel() >= 5) {
      console.debug(message || 'null');
    }
  }
  public static ignore(message: any) {
  }

}
